'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { useCallback } from 'react';
import Icon from '@/components/Icon/Icon';
import { DeviceAssignmentRuleContent } from '@/features/device-assignment-rule/components';
import { DeviceGroupCombobox } from '@/features/device-group/components/DeviceGroupCombobox';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { DeviceAssignmentRuleShell } from './-components/DeviceAssignmentRuleShell';
import { RuleAndPolicySearchSchema, type RuleAndPolicySearch } from './-zod-schema';
export const Route = createFileRoute('/_staff/devices/_list/rule-and-policy/')({
  validateSearch: zodValidator(RuleAndPolicySearchSchema),
  component: RouteComponent
});
function RouteComponent() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.devices.ruleAndPolicy'
  });
  useDocumentTitle(t('pageTitle'));
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const handleListFilterChange = useCallback((patch: {
    search?: string;
    filterPgId?: string;
    filterDgId?: string;
  }) => {
    navigate({
      // フィルタは onChange ごとに発火するため replace で history を積まない
      replace: true,
      search: (prev: RuleAndPolicySearch) => ({
        ...prev,
        search: patch.search !== undefined ? patch.search || undefined : prev.search,
        peopleGroupId: patch.filterPgId !== undefined ? patch.filterPgId || undefined : prev.peopleGroupId,
        deviceGroupId: patch.filterDgId !== undefined ? patch.filterDgId || undefined : prev.deviceGroupId
      })
    });
  }, [navigate]);
  return <DeviceAssignmentRuleShell>
      <DeviceAssignmentRuleContent listFilter={{
      search: search.search ?? '',
      filterPgId: search.peopleGroupId ?? '',
      filterDgId: search.deviceGroupId ?? ''
    }} onListFilterChange={handleListFilterChange} renderDeviceGroupFilter={props => <DeviceGroupCombobox {...props} allowClear startIcon={<Icon iconName="GroupIcon" colorVariant="muted" size={14} className="mr-2 shrink-0" />} emptyLabel={t('filter.all')} searchPlaceholder={t('form.deviceGroupSearchPlaceholder')} noResultsMessage={t('form.deviceGroupNoResults')} className="w-auto" />} />
    </DeviceAssignmentRuleShell>;
}